import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";
import { Pricing } from "./components/Pricing";
import { FAQ } from "./components/FAQ";
import { Waitlist } from "./components/Waitlist";
import { Footer } from "./components/Footer";
import { Checkout } from "./components/Checkout";
import { Toaster } from "./components/ui/toaster";

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Features />
    <HowItWorks />
    <Pricing />
    <FAQ />
    <Waitlist />
    <Footer />
  </>
);
import { useSectionTracking } from "./hooks/useSectionTracking";
import { useScrollTracking } from "./hooks/useScrollTracking";
import { captureEvent, captureException } from "./utils/posthog";
import { EVENTS, SECTIONS } from "./utils/analytics";

function App() {
  // Track scroll depth milestones
  useScrollTracking();

  // Track section views
  useSectionTracking(SECTIONS.HERO, 'hero');
  useSectionTracking(SECTIONS.FEATURES, 'features');
  useSectionTracking(SECTIONS.HOW_IT_WORKS, 'how-it-works');
  useSectionTracking(SECTIONS.PRICING, 'pricing');
  useSectionTracking(SECTIONS.FAQ, 'faq');

  // Track page load
  useEffect(() => {
    captureEvent(EVENTS.PAGE_LOADED, {
      page_url: window.location.href,
      page_title: document.title,
      referrer: document.referrer || 'direct',
      user_agent: navigator.userAgent,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
    });
  }, []);

  // Global error tracking
  useEffect(() => {
    // Track unhandled JavaScript errors
    const handleError = (event) => {
      captureException(new Error(event.message), {
        error_filename: event.filename,
        error_lineno: event.lineno,
        error_colno: event.colno,
        error_stack: event.error?.stack,
      });
    };

    // Track unhandled promise rejections
    const handleUnhandledRejection = (event) => {
      captureException(event.reason, {
        error_type: 'unhandled_promise_rejection',
        error_reason: event.reason?.toString(),
      });
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <div className="App bg-black min-h-screen">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
